import { Box } from "@mui/material";
import React from "react";
import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL
const img = imageBaseUrl + 'International-Relation/IndiaPage/dualdegree.png'
const DualDegree = () => {
  return (
    <Box id="twinning-programmes">
      <MainContainer
        com1={
          <ContentContainer
            Header={<Header content={"Dual Degree/Joint Degree & Twinning Programmes "} color="#00999E" />}
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={<>At <strong>Taksheela Institute of Education</strong>, we offer students the opportunity to pursue <strong> Dual Degree, Joint Degree, and Twinning Programs</strong> in collaboration with top universities. These programs provide a global learning experience, enabling students to earn <strong>internationally recognized qualifications</strong>  while studying in India and abroad.</>
                  
                }
              />
            }
          />
        }
        com2={<ImageContainer img={img} />}
      />
    </Box>
  );
};

export default DualDegree;
